import { render, staticRenderFns } from "./DocumentRequestsView.vue?vue&type=template&id=1b213b36"
import script from "./DocumentRequestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRequestsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports